export const FLAG_GETTING_ROUTES_DATA = 'FLAG_GETTING_ROUTES_DATA';
export const GET_ROUTES_DATA = 'GET_ROUTES_DATA';
export const CLEAR_ROUTES_DATA = 'CLEAR_ROUTES_DATA';
export const GET_ROUTE_DATA = 'GET_ROUTE_DATA';
export const CLEAR_ROUTE_DATA = 'CLEAR_ROUTE_DATA';
export const FLAG_ROUTE_DATA_ACTIVITY = 'FLAG_ROUTE_DATA_ACTIVITY';
